import { Base64 } from 'js-base64'
import { getQiniuUploadToken } from '@/api/common_api'
import EXIF from 'exif-js'

// 验证文件的格式、大小
export function validateImage(file) {
  const imgTypes = ['image/png', 'image/jpeg', 'image/jpg']
  const imageSize = file.size / 1024 / 1024

  if (!imgTypes.includes(file.type)) {
      throw new Error('上传图片只能是jpg、png、jpeg格式！')
  }

  if (imageSize > 20) {
      throw new Error('上传图片大小不能超过20MB！')
  }

  return true
}

export function uploadImage64(img64) {
  return new Promise(async (resolve, reject) => {
      let token = ''
      await getQiniuUploadToken().then(res => {
        token = res
      })
      // 指定文件名称，cg/时间戳-8位随机码 + .jpg
      const url = 'https://up.qiniup.com/putb64/-1/key/' + Base64.encode('ios/' + (+new Date()) + '-' + Math.floor(Math.random(1) * 1000000) + '.jpg')
      const xhr = new XMLHttpRequest()
      xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
              let newFile = JSON.parse(xhr.responseText) // hash key
              resolve(newFile.key)
          }
      }
      xhr.onerror = function (e) {
          reject(e)
      }
      xhr.open('POST', url, true)
      xhr.setRequestHeader('Content-Type', 'application/octet-stream')
      xhr.setRequestHeader('Authorization', 'UpToken ' + token)
      xhr.send(formatImg(img64))
  })
}

export function priviewUploadedImage(key = '', useDefaultImg = false, imageSize = 200) {
  // imageView2后缀清洗
  key = key.replace(/\?imageView2\/1\/w\/\d{0,3}$/, '')

  // 图片类型处理
  if (key.indexOf("http") > -1) {
      return key
  }
  if ((key.indexOf("static") > -1 || key === '') && useDefaultImg) {
      key = 'assets/shop_default.png'
  }
  return key ? `https://img.senguo.cc/${key}?imageView2/1/w/${imageSize}` : ''
}

export function removeUploadedImagePrefix(url) {
  return url.replace(/^https?:\/\/(\w+\.)+(\w+)\//, '')
}

export const zipImage = (file, quality) => {
  return new Promise((resolve, reject) => {
      quality = quality || calcImageQuality(file)

      EXIF.getData(file, function () {
          let orientation = EXIF.getTag(this, 'Orientation')

          const fileReader = new FileReader()
          fileReader.readAsDataURL(file)
          fileReader.onload = async () => {
              try {
                  resolve(canvasDataUrl(fileReader.result, quality, orientation))
              } catch (e) {
                  handleError()
              }
          }
          fileReader.onerror = () => {
              handleError()
          }
      })

      const handleError = () => {
          reject('压缩图片失败')
      }
  })
}


// 格式化base64图片
function formatImg(img64) {
  return img64.replace(/^data:image\/\w+;base64,/, '')
}

// 使用canvas压缩图片
function canvasDataUrl(path, quality, orientation) {
  return new Promise((resolve, reject) => {
      const img = new Image()
      img.src = path
      img.onload = () => {
          const canvas = rotateToOrientaion(img, orientation)
          resolve(canvas.toDataURL('image/jpeg', quality))
      }
      img.onerror = (e) => {
          reject('压缩图片失败')
      }
  })
}

// 计算图片的质量
function calcImageQuality(file) {
  const size = file.size / 1024 / 1024

  return Math.min(Math.max(1 / size, 0.3), 1)
}

/**
* 图片校正，参考自：https://github.com/moxiecode/moxie/blob/09eaf578f38480dc4b8e2017c473c496883b6168/bin/js/moxie.js
* @param img 
* @param orientation 
*/
function rotateToOrientaion(img, orientation) {
  const RADIANS = Math.PI / 180
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  const width = img.width
  const height = img.height

  if ([5, 6, 7, 8].includes(orientation)) {
      canvas.width = height
      canvas.height = width
  } else {
      canvas.width = width
      canvas.height = height
  }

  switch (orientation) {
      case 2:
          // horizontal flip
          ctx.translate(width, 0);
          ctx.scale(-1, 1);
          break;
      case 3:
          // 180 rotate left
          ctx.translate(width, height);
          ctx.rotate(180 * RADIANS);
          break;
      case 4:
          // vertical flip
          ctx.translate(0, height);
          ctx.scale(1, -1);
          break;
      case 5:
          // vertical flip + 90 rotate right
          ctx.rotate(90 * RADIANS);
          ctx.scale(1, -1);
          break;
      case 6:
          // 90 rotate right
          ctx.rotate(90 * RADIANS);
          ctx.translate(0, -height);
          break;
      case 7:
          // horizontal flip + 90 rotate right
          ctx.rotate(90 * RADIANS);
          ctx.translate(width, -height);
          ctx.scale(-1, 1);
          break;
      case 8:
          // 90 rotate left
          ctx.rotate(-90 * RADIANS);
          ctx.translate(-width, 0);
          break;
  }

  ctx.drawImage(img, 0, 0, width, height)

  return canvas
}